export class NoMatchError extends Error {
    property;
    constructor(property, message = 'No match found!') {
        super(message);
        this.property = property;
    }
}
export class FragileTypeSafetyError extends NoMatchError {
    constructor(property) {
        super(property, 'type safety in here is a bit fragile, check earlier in the stack');
    }
}
//# sourceMappingURL=Exceptions.js.map